module.exports = __webpack_public_path__ + "img/cctv.555bde35.png";